import React, { useState, useMemo, useRef, useEffect } from 'react';
import './MLOrganizationTypeaheadSearch.scss';
import { Icon } from '@jutro/legacy/components';

const MLOrganizationTypeaheadSearch = ({
    options = [],
    value,
    onChange,
    placeholder
}) => {
    const [search, setSearch] = useState('');
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!value) {
            return;
        }

        const selectedItem = options.find(
            ({ code }) => code === value
        );

        if (selectedItem) {
            setSearch(selectedItem.displayName);
        }
    }, [value, options]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                ref.current &&
                !ref.current.contains(event.target)
            ) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener(
                'mousedown',
                handleClickOutside
            );
        };
    }, []);

    const filteredOptions = useMemo(() => {
        const searchText = search.trim().toLowerCase();

        if (!searchText) {
            return options;
        }

        return options.filter((item) =>
            item.displayName
                ?.toLowerCase()
                .includes(searchText)
        );
    }, [search, options]);

    const highlightText = (text = '') => {
        if (!search.trim()) {
            return text;
        }

        const escapedSearch = search.replace(
            /[.*+?^${}()|[\]\\]/g,
            '\\$&'
        );

        const regex = new RegExp(
            `(${escapedSearch})`,
            'gi'
        );

        return text.split(regex).map((part, index) =>
            part.toLowerCase() ===
            search.toLowerCase() ? (
                <span
                    key={index}
                    className="highlight"
                >
                    {part}
                </span>
            ) : (
                part
            )
        );
    };

    const handleSelect = (item) => {
        onChange(item.code);
        setSearch(item.displayName);
        setOpen(false);
    };

    const handleSearchClick = () => {
        setOpen(true);
    };

    return (
        <div
            className="custom-org-dropdown"
            ref={ref}
        >
            <div className="input-wrapper">
                <input
                    value={search}
                    placeholder={placeholder}
                    autoComplete="off"
                    data-lpignore="true"
                    onFocus={() => setOpen(true)}
                    onChange={(e) => {
                        setSearch(e.target.value);
                        setOpen(true);
                    }}
                />

                <span
                    className="search-icon"
                    onClick={handleSearchClick}
                >
                    <Icon icon="search" />
                </span>
            </div>

            {open && (
                <div className="dropdown-menu">
                    {filteredOptions.length > 0 ? (
                        filteredOptions.map((item) => (
                            <div
                                key={item.code}
                                className="dropdown-item"
                                onClick={() =>
                                    handleSelect(item)
                                }
                            >
                                <span>
                                    {highlightText(
                                        item.displayName
                                    )}
                                </span>

                                {item.strategicPartnershipIndicator && (
                                    <span className="sp-badge">
                                        Strategic Partner
                                    </span>
                                )}
                            </div>
                        ))
                    ) : (
                        <div className="no-results">
                            No organizations found
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default MLOrganizationTypeaheadSearch;